import {
  type LocalAuthorityVerifyResult,
  verifyLocalAuthorityEnvelope,
} from '@streamlain/view-config';

import { getLocalAuthorityClientInstallId } from './local-authority-vault';

export function localAuthorityRequestHeaders(
  serverBaseUrl: string
): Record<string, string> {
  return {
    'x-streamlain-client-install-id': getLocalAuthorityClientInstallId(),
    'x-streamlain-local-authority-origin': canonicalServerOrigin(serverBaseUrl),
  };
}

/** The key and the key id of a purpose this build was given. */
export function signedLocalAuthorityKeys(expectedPurpose?: string): {
  publicKeySpki: string | null;
  expectedKid: string | null;
} {
  return {
    publicKeySpki: BUILD_CONFIG.featureEntitlementPublicKey ?? null,
    expectedKid:
      (expectedPurpose === 'permission-grant'
        ? BUILD_CONFIG.permissionGrantKid
        : BUILD_CONFIG.featureEntitlementKid) ?? null,
  };
}

/** Verifies an envelope with the key and key id this build was given. */
export function verifySignedLocalAuthorityEnvelope<Payload extends object>(
  envelope: unknown,
  options?: {
    expectedKid?: string;
    expectedPurpose?: string;
    publicKey?: string;
    now?: Date;
  }
): Promise<LocalAuthorityVerifyResult<Payload>> {
  const keys = signedLocalAuthorityKeys(options?.expectedPurpose);
  return verifyLocalAuthorityEnvelope<Payload>(envelope, {
    publicKeySpki: options?.publicKey ?? keys.publicKeySpki,
    expectedKid: options?.expectedKid ?? keys.expectedKid,
    expectedPurpose: options?.expectedPurpose,
    now: options?.now ?? new Date(),
  });
}

function canonicalServerOrigin(value: string): string {
  return new URL(value).origin.toLowerCase();
}
